import {type AppDispatch, type RootState} from "../../../../../store";
import {serviceFindingTenantWriteToStorage} from "../utils/findingTenantHandleStorage";
import addServiceFindingTenant from "./saveServiceFindTenant";

export const serviceFindTenantCheckout  = (unitID?: number) => (data: any) => async (dispatch: AppDispatch, getState: () => RootState): Promise<any> => {
    serviceFindingTenantWriteToStorage('service_finding_tenant_checkout', data)
    return await dispatch(addServiceFindingTenant(Number(unitID)))
}